import apps from "@services/applications";

export default [
  {
    path: "/app/user-manager",
    name: "user-manager",
    meta: {
      module: "user-manager",
      application: apps.Modules.UserManager.Id,
      title: apps.Modules.UserManager.Name
    },
    component: () => import("@UserManager/views/UserManager.vue"),
    children: []
  }
];
